<template>
  <div id="CreateUpdateRoute">
    <v-dialog max-width="600" scrollable persistent v-model="routeDialog">
      <v-card>
        <v-card-title>Save Route</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-3">
          <v-form ref="form1">
            <v-text-field class="py-1 mt-5" dense :rules="[rules.nameRequired]" clearable label="Enter Route Name*"
                          outlined ref="routeName"
                          v-model="routeData.name"></v-text-field>
            <v-autocomplete class="py-1" dense :items="drivers" clearable item-text="name" item-value="id"
                            label="Select Default Salesman" outlined
                            v-model="routeData.driverId"></v-autocomplete>
            <v-autocomplete class="py-1" dense :items="vehicles" clearable item-text="name" item-value="id"
                            label="Select Default Vehicle" outlined
                            v-model="routeData.vehicleId">
              <template v-slot:selection="data">
                {{ data.item.name }} ({{ data.item.platNo }})
              </template>
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.name"></v-list-item-title>
                  <v-list-item-subtitle v-html="data.item.platNo"></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn @click="cancel" class="mr-2 white elevation-0">CANCEL</v-btn>
          <v-btn @click="save" elevation="0" color="primary">SAVE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { IDS } from '@/Constants/IDS'
import { GET_USERS_BY_TYPE } from '@/graphql/queries/Users'
import { GET_VEHICLES_BY_TYPE } from '@/graphql/queries/Vehicles'
import { CREATE_UPDATE_ROUTE } from '@/graphql/mutations/Routes'

export default {
  name: 'CreateUpdateRoute',
  props: {
    route: { type: Object, default: null },
    routeDialog: { type: [Boolean], default: false },
  },
  data () {
    return {
      vehicles: [], drivers: [],
      routeData: { id: '', name: '', driverId: '', vehicleId: '', organizationId: '' },
      loggedInUser: JSON.parse(localStorage.user),
      rules: { nameRequired: value => !!value || 'Route Required.' },
    }
  },
  apollo: {
    Users: {
      query: GET_USERS_BY_TYPE, fetchPolicy: 'network-only',
      skip () { return !this.loggedInUser },
      variables () { return { orgId: this.loggedInUser.organizationId, userTypeId: IDS.userTypes.Driver } },
      result ({ data, loading }) { if (!loading) { this.drivers = data.Users } },
    },
    Vehicles: {
      query: GET_VEHICLES_BY_TYPE, fetchPolicy: 'network-only',
      skip () { return !this.loggedInUser },
      variables () { return { orgId: this.loggedInUser.organizationId, vehicleType: IDS.vehicleType.Tempo } },
      result ({ data, loading }) { if (!loading) { this.vehicles = data.Vehicles } },
    },
  },
  methods: {
    async saveRoute () {
      let routes = {
        name: this.routeData.name,
        driverId: this.routeData.driverId ? this.routeData.driverId : null,
        vehicleId: this.routeData.vehicleId ? this.routeData.vehicleId : null,
        organizationId: this.loggedInUser.organizationId,
      }
      if (this.route)
        routes['id'] = this.route.id
      let route_on_conflict_rule = {
        constraint: 'Routes_pkey', update_columns: ['name', 'driverId', 'organizationId', 'vehicleId'],
      }
      let response = await this.$apollo.mutate({
        mutation: CREATE_UPDATE_ROUTE,
        variables: {
          routes: routes, route_on_conflict_rule: route_on_conflict_rule,
        },
      })
      if (response.data)
        this.$emit('saveRoute')
    },
    save () {
      if (this.$refs.form1.validate())
        this.saveRoute()
    },
    cancel () {
      this.$emit('cancel')
    },
  },
  mounted () {
    if (this.route)
      this.routeData = JSON.parse(JSON.stringify(this.route))
  },
}
</script>
